<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn outlined color="primary" dark v-on="on">
          Start Shopping
          <!-- <v-icon right>mdi-chevron-right</v-icon> -->
        </v-btn>
      </template>

      <v-card>
        <v-toolbar color="background" flat dense>
          <v-toolbar-title>Start Shopping</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-form
          ref="postcodeForm"
          @submit.prevent="submit()"
          v-model="valid"
          class="mt-2 text-center"
        >
          <v-card-text>
            <v-alert class="text-left" border="left" text type="info">
              To get started just let us know your postcode so we can accurately
              show which days we can deliver to you.
            </v-alert>

            <v-text-field
              color="primary"
              v-model="postcode"
              prepend-inner-icon="mdi-home"
              outlined
              :rules="[required('PostCode'), isPostCode]"
              label="Postcode"
            />
          </v-card-text>

          <v-card-actions class="dialogActions">
            <v-spacer />
            <v-btn
              outlined
              :disabled="!valid"
              color="blue darken-2"
              class="white--text"
              @click="submit()"
              :loading="loading"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cncDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <h4>Click & Collect Only</h4>
          <v-spacer></v-spacer>
          <v-btn icon color text @click="cncDialog = false">
            <v-icon>mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-card-title>

        <v-form
          ref="cncOnlyForm"
          @submit.prevent="authAnon()"
          class="mt-2 text-center"
        >
          <v-card-text>
            <v-alert class="text-left" border="left" text type="warning">
              Unfortunately we do not deliver to your postcode
              {{ this.postcode }} however Click & Collect is available if you'd
              still like to place an order.
            </v-alert>
          </v-card-text>

          <v-card-actions class="dialogActions">
            <v-spacer />
            <v-btn
              outlined
              color="blue darken-2"
              @click="authAnon()"
              :loading="loading"
            >
              Proceed
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import checkPostCode from "@/util/validation/postcode.js";

export default {
  data() {
    return {
      dialog: false,
      cncDialog: false,

      loading: false,
      valid: false,

      postcode: null,
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isPostCode: (val) => {
        return checkPostCode(val);
      },
    };
  },

  methods: {
    ...mapActions([
      "checkDeliveryPostcode",
      "authAnonUser",
      "setAnonUser",
      "getCustomer",
      "setGuestTrolly",
      "setSnackbar",
    ]),

    async submit() {
      if (this.$refs.postcodeForm.validate()) {
        this.loading = true;

        const params = Object.assign(
          { identity: "nws9987" },
          { postcode: this.postcode }
        );

        const postcodeResponse = await this.checkDeliveryPostcode(params);
        console.log(postcodeResponse);

        if (postcodeResponse) {
          if (postcodeResponse.success) {
            if (postcodeResponse.cncOnly) {
              // We only allow CNC so ensure the User knows this by showing the appropriate dialog
              this.cncDialog = true;
            } else {
              //We're not CNC only so just log in
              await this.authAnon();
            }
          } else {
            //auth-user failed
            this.setSnackbar({
              color: "error",
              text:
                "Unfortunately we do not deliver to this postcode at this time.",
            });
          }
        } else {
          //auth-user failed
          this.setSnackbar({
            color: "error",
            text: "Error checking your postcode",
          });
        }
      }

      this.loading = false;
      this.dialog = false;
    },

    async authAnon() {
      //Call to Log in Here
      let payload = {
        identity: "nws9987",
        postcode: this.postcode,
      };

      this.loading = true;

      console.log("-- Auth anon");
      console.log(payload);

      let response = await this.authAnonUser(payload);

      console.log("Response");
      console.log(response);

      if (response.success) {
        this.setAnonUser(true);

        let customerResponse = await this.getCustomer();
        console.log("-- Customer Response");
        console.log(customerResponse);

        //
        if (customerResponse.success) {
          if (customerResponse.allAvailableDays.length > 0) {
            //Use the last available date as our order date
            let payload = {
              trolly: [],
            };

            let guestTrolly = {
              id: 0,
              trolly_items: {},
              order_date:
                customerResponse.allAvailableDays[
                  customerResponse.allAvailableDays.length - 1
                ],
            };

            payload.trolly.push(guestTrolly);

            console.log("-- Setting Guest Trolly");
            console.log(payload);

            this.$router.push({ name: "Home" });
          } else {
            //No Days available for the guest user to order on
            this.setSnackbar({
              color: "error",
              text:
                "There are currently no valid order days enabled for this customer",
            });
          }
        } else {
          //get-customer failed
          this.setSnackbar({
            color: "error",
            text: "Error retrieving customer details",
          });
        }
      } else {
        if (response.message) {
          console.log("-- Setting Snackbar");

          this.$store.dispatch("snackbarStatic/setSnackbar", {
            text: response.message,
            color: "error",
          });
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>